var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1501_53830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.92971 6.28125H10.0423C10.4137 5.51043 9.85151 4.60156 8.98573 4.60156C8.12159 4.60156 7.55678 5.50898 7.92971 6.28125Z",
    fill: "#80A2DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98572 3.42969C10.4785 3.42969 11.598 4.81441 11.2741 6.28125H14.2592V4.99219C14.2592 4.77645 14.0843 4.60156 13.8685 4.60156H13.0801C12.9903 4.28703 12.865 3.9875 12.7092 3.70727L13.267 3.14941C13.4195 2.99687 13.4195 2.74953 13.267 2.59699L12.1622 1.49215C12.0096 1.33961 11.7623 1.33961 11.6097 1.49215L11.0519 2.05C10.7717 1.89414 10.4721 1.76887 10.1576 1.67898V0.890625C10.1576 0.674883 9.98271 0.5 9.76697 0.5H8.20447C7.98873 0.5 7.81384 0.674883 7.81384 0.890625V1.67902C7.49931 1.76887 7.19978 1.89418 6.91955 2.05004L6.36169 1.49215C6.20916 1.33961 5.96181 1.33961 5.80927 1.49215L4.70443 2.59699C4.55189 2.74953 4.55189 2.99687 4.70443 3.14941L5.26232 3.70727C5.1065 3.9875 4.98119 4.28703 4.89134 4.60156H4.10291C3.88716 4.60156 3.71228 4.77645 3.71228 4.99219V6.28125H6.69869C6.37291 4.81059 7.49615 3.42969 8.98572 3.42969Z",
    fill: "#80A2DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7667 12.9086L16.4671 9.46992C16.4279 8.77422 16.2882 8.09922 16.0503 7.45312H2.06339C0.743854 11.0355 2.54815 15.1667 6.32249 16.5059V19.9141C6.32249 20.2375 6.5846 20.5 6.90842 20.5H13.5881C13.9115 20.5 14.174 20.2375 14.174 19.9141V16.9062H15.8928C16.2162 16.9062 16.4787 16.6438 16.4787 16.3203V13.8203H18.2795C18.7467 13.8203 19.0268 13.2977 18.7667 12.9086Z",
    fill: "#80A2DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1501_53830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.25 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/general.39434dc9761927752542865f54ddf130.svg";
export { ForwardRef as ReactComponent };